import React from "react";
import Form1 from "./Form1";
function Section1() {

    return (
        <section className="section1">
            <Form1 />
        </section>
    );
};
export default Section1;
